import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import Header from '../common/Header'
import SideMenu from '../common/SideMenu'

import './ShopPayment.css'


import CouponModal from './Modal/CouponModal'
import { useTranslation } from "react-i18next";

const ShopPayment = () => {
  const { t } = useTranslation();

  const [couponCreating, setCouponCreating] = useState(false)
  const [couponInfo, setCouponInfo] = useState({})
  const [isOpen, setIsOpen] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const modalClose = () => {
    setIsOpen(false)
  }

  useEffect(() => {
    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
      xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
      token = token.split('=')[1]
    }
    fetch(process.env.REACT_APP_API_URL + '/api/shop', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Bearer': decodeURIComponent(token),
      },
      credentials: 'include',
    })
      .then(response => response.json())
      .then(data => {
        const shop = data.shop;
        if (shop.is_shoppayment_enabled == 0) {
          setErrorMessage(t('shop_payment.error'));
          setCouponPoints([]);
        }
      }).catch(error => {
        // window.location.href = '/' + shop;
      });
  }, [])

  const createQouponQr = (e) => {

    setErrorMessage('');
    const initialValue = e.target.innerHTML;
    e.target.innerHTML = t('common.loading');

    const point = e.target.value;
    console.log(`e.target.value[${point}]`)

    setCouponCreating(true)

    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }

    fetch(`${process.env.REACT_APP_API_URL}/api/payment-create-coupon`, {
      method: 'POST',
      headers: {
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Bearer': decodeURIComponent(token),
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify({
          point: point,
      })

    })
    
    .then(response => response.json())
    .then(data => {
      console.log(data)
      if(!data.errors) {
      
        if (data.hasError) {
          setErrorMessage(data.message);

        } else {
          setCouponInfo(data.coupon_info);
          setIsOpen(true);

        }

        e.target.innerHTML = initialValue;
        setCouponCreating(false)
      }

    })
    .catch(error => {
      e.target.innerHTML = initialValue;
      setCouponCreating(false);
      setErrorMessage(error.message);


    });


  }
  
  const [couponPoints, setCouponPoints] = useState( [500, 1000, 5000, 10000, 50000, 100000, 200000, 300000, 500000])
  

  return (
    <>
      <Header />
      <SideMenu />

      <div className="shop-payment">
        <div className="shop-payment-title">{t('shop_payment.title')}</div>
          {errorMessage !== '' && 
              <div className="shop-payment-error_message">{errorMessage}</div>
          }
          <div className="point-list">
            { couponPoints.map((row, index) => {
                return (
                    <div key={index} className="point-list-item">
                        <img src="../img/balance.svg" alt="balance" /> {`${Intl.NumberFormat("ja-JP").format(row)}pt`}
                        <button className="point-list-item-button" disabled={ ( couponCreating ? 'disabled' : '' ) } 
                          onClick={createQouponQr} value={row}>{`${t('shop_payment.yen')}${Intl.NumberFormat("ja-JP").format(row)}`}</button>
                    </div>
                )
              })
            }
          </div>
        </div>
        <CouponModal isOpen={isOpen} onRequestClose={modalClose} couponInfo={couponInfo} />


    </>
  )
}

export default ShopPayment